import React, { PropsWithChildren, Fragment } from "react";
import { EPermissionLevel } from "../../interfaces/ICategoryPermission";
import { useCategoryPermission } from "../../store/selectors/permissionSelectors";

type IRenderProps = { permissionGranted: boolean; permissionLevel?: EPermissionLevel };

interface IProps {
    categoryId: number;
    permissionType: "read" | "edit" | "create";
    minimumPermission: EPermissionLevel;
    render: (data: IRenderProps) => any
}

export const RenderPermissionForCategory: React.FC<IProps> = (props) => {
    const { categoryId, permissionType, minimumPermission, render } = props;

    const permissionsForCategory = useCategoryPermission(categoryId);
    const permissionLevel = permissionsForCategory[permissionType];


    return (
        <Fragment>
            {render({
                permissionGranted: permissionLevel >= minimumPermission,
                permissionLevel
            })}
        </Fragment>
    )
};
